import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useExportOrderFormSchema = () => {
  const { t } = useTranslation("order", {
    keyPrefix: "orderListPage.exportModal.errors"
  });

  const schema = useMemo(
    () =>
      z.object({
        productTypes: z.array(z.string()),
        productIds: z.array(z.string()).optional(),
        orderStatuses: z.array(z.string()),
        exportFormat: z.enum(["csv", "xlsx"]),
        doneSendTo: z.enum(["email", "device"]),
        start_date: z.string().optional(),
        end_date: z.string().optional()
      }),
    [t]
  );

  return schema;
};

export type ExportOrderFormSchema = z.infer<
  ReturnType<typeof useExportOrderFormSchema>
>;
